import React from 'react';
import type { ISigner } from '../../../store/senderBuild/types';
import { RecipientsHeader } from './../../common/RecipientsHeader';
import { useStyles, renderSigner } from './index';

interface IProps {
  // signingGroup: ISigningGroup;
  signers: ISigner[];
  index: number;
  // moveSigner: (signerId: string, newGroupId: string) => void;
  totalSigningGroups: number;
}

export function SigningGroup(props: IProps) {
  const { signers, index, totalSigningGroups } = props;
  const classes = useStyles();
  return (
    <div className={`${classes.signingGroup}`}>
      {totalSigningGroups > 1 ? <RecipientsHeader index={index} /> : ''}
      {signers.map((s, i) => (
        <div key={s.signerId}>{renderSigner(classes, s, false, i)}</div>
      ))}
    </div>
  );
}
